var accordionHandler = {

    accordionTitle: $('h5.accordion-reskin'),
    

    toggleContent: function ($target) {
        $target.next().toggleClass('accordion-open');
    },

    rotateArrow: function ($target) {
        $target.children().first().toggleClass('upwards');
    },

    init: function () {
        // If element exsists
        if (accordionHandler.accordionTitle.length > 0) {
            accordionHandler.accordionTitle.on('click', function (e) {
                e.preventDefault();
                accordionHandler.toggleContent($(e.target));
                accordionHandler.rotateArrow($(e.target));
            });
        }
    }
};
